import './style.css';
import CircularProgress from '@mui/material/CircularProgress';

const Loading = () => {
  return (
    <div
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        color: 'var(--title)',
      }}
    >
      <CircularProgress color="primary" />
      <p style={{ marginTop: '15px' }}>Carregando itens...</p>
    </div>
  );
};

export default Loading;
